// 法人登陆
export let zjzwfwLegalLoginUrl = 'https://esso.zjzwfw.gov.cn/opensso/spsaehandler/metaAlias/sp'

// 个人登陆
export let zjzwfwPersonLoginUrl =
  'https://puser.zjzwfw.gov.cn/sso/usp.do?action=ssoLogin&servicecode=gxpt'

// pc统一登陆地址
export const PC_LOGIN_URL = 'https://portal.zjzwfw.gov.cn/uc/sso/login'
const APPID = '2001999672'
const PERSON_APPID = '2001999672_1'
const LEGAL_APPID = '2001999672_2'

// const loginCallBackMap = {
//   demo: 'http://223.4.64.21:3006/api/sso/user/corporation/token',
//   dev: 'http://223.4.64.21:3006/api/sso/user/corporation/token',
//   test: 'http://223.4.64.21:3006/api/sso/user/corporation/token',
//   pre: 'https://loanh5.zjfcs.org.cn/api/sso/user/corporation/token',
//   qProd: 'http://223.4.64.21:3008/api/sso/user/corporation/token',
//   prod: 'https://loanh5.zjfcs.org.cn/api/sso/user/corporation/token',
//   testMicroApp: 'http://223.4.64.21:3006/api/sso/user/corporation/token',
//   prodMicroApp: 'https://loanh5.zjfcs.org.cn/api/sso/user/corporation/token'
// }

const h5Url = {
  development: 'http://192.168.251.21:8080',
  demo: 'http://192.168.253.113',
  dev: 'https://waftest.zjfcs.org.cn',
  // test: 'https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001815934/lastTest/index.html',
  test: 'https://waftest.zjfcs.org.cn',
  pre: 'http://223.4.64.21:3008',
  qProd: 'http://223.4.64.21:3008',
  prod: 'https://zjsybjjzfw.yyhj.zjzwfw.gov.cn',
  // prod: 'https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001815934/reserved/index.html',
  // testMicroApp: 'https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001815934/lastTest/index.html',
  testMicroApp: 'https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001815934/lastTest/index.html?debug=true',
  // testMicroApp: 'https://waftest.zjfcs.org.cn',
  prodMicroApp: 'https://mapi.zjzwfw.gov.cn/web/mgop/gov-open/zj/2001815934/reserved/index.html'
  // prodMicroApp: 'https://zjsybjjzfw.yyhj.zjzwfw.gov.cn'
}

export function getCurEnvH5Url() {
  return h5Url[process.env.VUE_APP_ENV]
}

// 法人登陆 完整
let getZjzwfwLegalLoginUrlSplice = (currentUrl) => {
  const URLParams = new URLSearchParams(window.location.search)
  const areaId = URLParams.get('areaId')
  const urlParams = `userType=legal&appId=${LEGAL_APPID}&env=${process.env.VUE_APP_ENV.includes('prod') ? 'prod' : 'test'}`
  const areaIdParam = areaId ? `?areaId=${areaId}&${urlParams}` : `?${urlParams}`
  // goto 地址
  let gotoURL = currentUrl
    ? `${currentUrl}${areaIdParam}`
    : `${window.location.origin}${window.location.pathname}${areaIdParam}`
  return `${PC_LOGIN_URL}?appId=${LEGAL_APPID}&sp=${encodeURIComponent(gotoURL)}`
}

// 个人登录 完整
let getZjzwfwPersonLoginUrlSplice = (currentUrl) => {
  const URLParams = new URLSearchParams(window.location.search)
  const areaId = URLParams.get('areaId')
  const urlParams = `userType=person&appId=${PERSON_APPID}&env=${process.env.VUE_APP_ENV.includes('prod') ? 'prod' : 'test'}`
  const areaIdParam = areaId ? `?areaId=${areaId}&${urlParams}` : `?${urlParams}`
  // goto 地址
  let gotoURL = currentUrl
    ? `${currentUrl}${areaIdParam}`
    : `${window.location.origin}${window.location.pathname}${areaIdParam}`
  return `${PC_LOGIN_URL}?appId=${PERSON_APPID}&sp=${encodeURIComponent(gotoURL)}`
}
// 登录
let getZjzwfwLoginUrlSplice = (currentUrl) => {
  // 政务网挂载在window的属性
  const zjzwIsUser = window.zjzwIsUser
  // 本服务本次存储的用户状态
  const USERTYPE = sessionStorage.getItem('USERTYPE')
  let userType = 'person'
  if (zjzwIsUser === '2' || USERTYPE === '法人') {
    userType = 'legal'
  }
  const URLParams = new URLSearchParams(window.location.search)
  const areaId = URLParams.get('areaId')
  const urlParams = `userType=${userType}&appId=${APPID}&env=${process.env.VUE_APP_ENV.includes('prod') ? 'prod' : 'test'}`
  const areaIdParam = areaId ? `?areaId=${areaId}&${urlParams}` : `?${urlParams}`
  // goto 地址
  let gotoURL = currentUrl
    ? `${currentUrl}${areaIdParam}`
    : `${window.location.origin}${window.location.pathname}${areaIdParam}`
  return `${PC_LOGIN_URL}?appId=${APPID}&sp=${encodeURIComponent(gotoURL)}&userType=${userType}`
}

export { getZjzwfwLegalLoginUrlSplice, getZjzwfwPersonLoginUrlSplice, getZjzwfwLoginUrlSplice }
